module.exports = "/_next/static/files/9dd0b1565b7e4a34b5acc3859c749a74.svg";